import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function faqDataReducer(state = initialState.faqData, action) {
  if (action.type === types.LOAD_FAQ_DATA_SUCCESS) {
    return action.faqData;
  }
  return state;
}
